/*
 * The catalogue's half of the toast region.
 *
 * `ToastProvider` takes its labels as props because the design system holds no catalogue — the same
 * arrangement `AppShell` uses for `ShellLabels`, and for the same reason: FE-03 looks at the apps,
 * so a package that shipped English would put user-facing strings where the gate cannot see them.
 * Props cannot come from a hook at the point `main.tsx` composes providers, so this is the four-line
 * component that closes that gap.
 */

import { ToastProvider } from '@indovation/design-system';
import { useI18n } from '@indovation/i18n/react';
import type { ReactNode } from 'react';

export function Toasts({ children }: { children: ReactNode }) {
  const { t } = useI18n();

  return (
    <ToastProvider labels={{ region: t('toast.region'), dismiss: t('toast.dismiss') }}>
      {children}
    </ToastProvider>
  );
}
